export interface StatoIntervento {
    id: number;
    descrizione: string;
}

export enum StatoInterventoEnum {
  INPREPARAZIONE = "IN PREPARAZIONE",
  PRESENTATO = "PRESENTATO",
  DA_RIMODULARE = "DA RIMODULARE",
  DA_FINANZIARE = "DA FINANZIARE",
  FINANZIATO = "FINANZIATO",
  NON_FINANZIATO = "NON FINANZIATO",
  RENDICONTATO_PARZIALMENTE = "RENDICONTATO PARZIALMENTE",
  RENDICONTATO_COMPLETAMENTE = "RENDICONTATO COMPLETAMENTE",
  ANNULLATO = "ANNULLATO",
}
